import type { QueryClient } from "@tanstack/react-query";

import type { AnalysisHighlights, HighlightsOverview, HighlightView } from "../model/Highlight";
import {
  ANALYSIS_HIGHLIGHTS_QUERY_KEY,
  HIGHLIGHTS_OVERVIEW_QUERY_KEY,
} from "./HIGHLIGHTS_QUERY_KEYS";

// Ответ мутации (моменты с новым статусом клипа) сразу кладётся во все кэши хайлайтов:
// кнопка меняется на «В очереди» без перезапроса.
export const patchHighlights = (queryClient: QueryClient, items: HighlightView[]): void => {
  const byId = new Map(items.map((item) => [item.id, item]));
  const swap = (item: HighlightView): HighlightView => byId.get(item.id) ?? item;
  queryClient.setQueriesData<AnalysisHighlights>(
    { queryKey: ANALYSIS_HIGHLIGHTS_QUERY_KEY },
    (data) => (data === undefined ? data : { ...data, items: data.items.map(swap) }),
  );
  queryClient.setQueriesData<HighlightsOverview>(
    { queryKey: HIGHLIGHTS_OVERVIEW_QUERY_KEY },
    (data) =>
      data === undefined
        ? data
        : {
            ...data,
            ready: data.ready.map(swap),
            matches: data.matches.map((match) => ({ ...match, items: match.items.map(swap) })),
          },
  );
};
